import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import TargetGroup from './target-group-model'
import {
  CreateTargetGroupAsync,
  DeleteTargetGroupAsync,
  LoadTargetGroupsAsync,
} from './targetGroup-thunk'
const initialState: targetGroupSliceState = {
  targetGroup: [],
  selected_targetGroup: '',
  is_loading_targetGroup: false,
  is_creating_targetGroup: false,
  is_deleting_targetGroup: false,
}
export interface targetGroupSliceState {
  targetGroup: TargetGroup[]
  selected_targetGroup?: string
  is_loading_targetGroup: boolean
  is_creating_targetGroup: boolean
  is_deleting_targetGroup: boolean
}
export const targetGroupSlice = createSlice({
  name: 'targetGroup',
  initialState,
  reducers: {
    setSelectedtargetGroup: (state, action) => {
      state.selected_targetGroup = action.payload
    },
    clearStatetargetGroup: (state) => {
      state.targetGroup = []
      state.is_loading_targetGroup = false
      state.is_creating_targetGroup = false
      state.is_deleting_targetGroup = false
    },
    mergetargetGroup: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_targetGroup = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.targetGroup = merge(state.targetGroup, payload) as any
        }
      }
    },

    add_targetGroup: (state, action) => {
      if (action.payload) {
        state.targetGroup = [...state.targetGroup, action.payload]
      }
    },
    set_targetGroup: (state, action) => {
      let { key, value, id } = action.payload
      state.targetGroup = state.targetGroup.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTargetGroupsAsync.pending, (state) => {
      state.is_loading_targetGroup = true
    })
    builder.addCase(LoadTargetGroupsAsync.fulfilled, (state, action) => {
      state.is_loading_targetGroup = false
      if (action.payload) {
        state.targetGroup = action.payload
      }
    })
    builder.addCase(LoadTargetGroupsAsync.rejected, (state) => {
      state.is_loading_targetGroup = false
    })
    builder.addCase(CreateTargetGroupAsync.pending, (state) => {
      state.is_creating_targetGroup = true
    })
    builder.addCase(CreateTargetGroupAsync.fulfilled, (state) => {
      state.is_creating_targetGroup = false
    })
    builder.addCase(CreateTargetGroupAsync.rejected, (state) => {
      state.is_creating_targetGroup = false
    })
    builder.addCase(DeleteTargetGroupAsync.pending, (state) => {
      state.is_deleting_targetGroup = true
    })
    builder.addCase(DeleteTargetGroupAsync.fulfilled, (state, action) => {
      state.is_deleting_targetGroup = false
      if (state.targetGroup) {
        state.targetGroup = state.targetGroup.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteTargetGroupAsync.rejected, (state) => {
      state.is_deleting_targetGroup = false
    })
  },
})

export const {
  clearStatetargetGroup,
  setSelectedtargetGroup,
  set_targetGroup,
  mergetargetGroup,
  add_targetGroup,
} = targetGroupSlice.actions

export const get_targetGroup =
  (id?: string) =>
  (state: {
    targetGroup: {
      targetGroup: TargetGroup[]
    }
  }): TargetGroup | null => {
    let temp = state?.targetGroup?.targetGroup?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.targetGroup?.targetGroup[0] || null
  }
export const get_selected_targetGroup = (state: {
  targetGroup: targetGroupSliceState
}): TargetGroup | null => {
  let id = state?.targetGroup?.selected_targetGroup
  let temp = state?.targetGroup?.targetGroup?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_targetGroup = (state: {
  targetGroup: {
    targetGroup: TargetGroup[]
  }
}): TargetGroup[] => {
  let temp = state?.targetGroup?.targetGroup
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_targetGroup_busy = (state: {
  targetGroup: targetGroupSliceState
}) => {
  return (
    state?.targetGroup.is_deleting_targetGroup ||
    state?.targetGroup.is_loading_targetGroup ||
    state?.targetGroup.is_creating_targetGroup
  )
}
export const is_deleting_targetGroup_busy = (state: {
  targetGroup: targetGroupSliceState
}) => {
  return state?.targetGroup.is_deleting_targetGroup
}
export const is_loading_targetGroup_busy = (state: {
  targetGroup: targetGroupSliceState
}) => {
  return state?.targetGroup.is_loading_targetGroup
}
export const is_creating_targetGroup_busy = (state: {
  targetGroup: targetGroupSliceState
}) => {
  return state?.targetGroup.is_creating_targetGroup
}

export default targetGroupSlice.reducer
